import { ref } from "vue";
import { defineStore } from "pinia";

export const useSidebarStore = defineStore("sidebar", () => {
  const isClosed = ref<boolean>(false);

  return {
    isClosed,
  };
});
